// src/components/VideoPlayer.jsx
import React from 'react';
import PropTypes from 'prop-types';
import './VideoPlayer.css';

export default function VideoPlayer({ title, youtubeId }) {
  return (
    <div className="video-player">
      <h3 className="video-player__title">{title}</h3>

      {youtubeId ? (
        <div className="video-player__embed">
          <iframe
            src={`https://www.youtube.com/embed/${youtubeId}`}
            title={title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      ) : (
        <div className="video-player__unavailable">
          <p>Vídeo não disponível</p>
        </div>
      )}
    </div>
  );
}

VideoPlayer.propTypes = {
  title:     PropTypes.string.isRequired,
  youtubeId: PropTypes.string,
};

VideoPlayer.defaultProps = {
  youtubeId: null,
};
